module.exports = __webpack_public_path__ + "static/media/ic_leave_apply.a3cb9f68.png";